import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";

const IconFire = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "109"}
    height={props.height || "108"}
    viewBox="0 0 109 108"
    fill="none"
  >
    <path
      d="M102.982 84.4279C103.52 109.422 14.3704 109.418 14.9203 84.4257C14.3814 59.4334 103.531 59.4377 102.982 84.4279Z"
      // the glow on the ground under the fire: a soft warm pool on a light page, an ember bed on a dark one
      // (src/theme/jungleThemeArtwork.css)
      fill="var(--jungle-art-campfire-ground, #FFDA9F)"
    />
    <path
      d="M3.95739 65.1859C4.62464 70.9445 9.19216 84.3114 9.20682 84.3978L45.8867 72.6758V60.1484L45.3419 59.9426L37.4038 56.897C37.4038 56.897 29.5389 60.7842 20.511 62.2191C11.1977 64.2595 2.98802 60.3646 3.95739 65.1859Z"
      fill="#9E4B39"
    />
    <path
      d="M6.32608 65.6046C9.47114 64.7069 12.8494 65.0265 16.0864 64.7802C18.0588 64.6576 19.9442 63.9545 21.9404 63.865C19.9645 63.5963 18.0521 64.1546 16.0592 64.2079C12.828 64.3719 9.31047 64.1552 6.32608 65.6046Z"
      fill="#5C2D33"
    />
    <path
      d="M38.6208 63.6605C36.2021 63.1427 33.9342 64.3137 31.6868 65.0168C29.4418 65.6853 26.924 65.6131 24.8057 66.7305C27.1029 66.0637 29.5262 66.2721 31.8441 65.6009C34.0925 64.8946 36.1773 63.6267 38.6208 63.6605Z"
      fill="#5C2D33"
    />
    <path
      d="M23.1683 72.0842C21.986 71.6858 20.6544 71.4344 19.4517 71.9885C18.9612 72.292 18.4274 72.4905 17.8351 72.4582C16.622 72.2977 15.3624 72.6751 14.1902 73.0222C12.4331 73.2954 10.3061 73.2031 8.94391 74.5576C10.5457 73.5096 12.4618 73.8139 14.2758 73.5888C15.4858 73.305 16.54 72.9032 17.8458 73.03C20.1057 72.7463 20.0282 71.516 23.1683 72.0842Z"
      fill="#5C2D33"
    />
    <g opacity="0.7">
      <path
        d="M3.95738 65.1855C4.62463 70.9441 9.19215 84.3111 9.20682 84.3975L45.8867 72.6755V66.0091C29.9202 64.1563 17.9942 80.1562 13.0274 73.6805C7.88638 66.9775 4.50814 65.6697 3.95738 65.1855Z"
        fill="#7C293B"
      />
    </g>
    <path
      d="M9.2067 84.3974C11.3346 83.1094 9.2267 78.8646 8.31102 73.8016C6.97038 68.8507 6.21973 64.5612 4.21798 63.1389C-1.3831 67.1291 5.90691 85.7051 9.2067 84.3974Z"
      fill="#B66B41"
    />
    <g opacity="0.6">
      <path
        d="M10.0969 82.7806C10.2223 80.7826 6.86087 67.3592 5.76748 65.3125C2.30424 69.2785 7.29949 82.3567 10.0969 82.7806Z"
        fill="#FFCA64"
      />
    </g>
    <g opacity="0.4">
      <path
        d="M4.21776 63.1391C4.21776 63.1391 7.67505 62.6486 17.6533 65.3128C27.0863 67.8316 34.2675 58.9068 45.3417 59.9423L37.4037 56.8967C37.4037 56.8967 29.5387 60.7839 20.5109 62.2189C11.4836 63.6538 6.06438 62.0675 4.21776 63.1391Z"
        fill="#FFCA64"
      />
    </g>
    <path
      d="M56.7023 84.3247L23.5463 107.623C23.5463 107.623 18.327 108.986 9.42053 106.528C2.20105 104.817 -3.05254 93.6404 2.86929 88.5205C7.92299 85.125 38.1681 67.9547 38.1748 67.9525C46.2155 67.2864 50.9201 68.9999 53.6265 71.5429C57.5549 74.5555 57.4472 82.674 56.7023 84.3247Z"
      fill="#9E4B39"
    />
    <path
      d="M10.5414 87.3388C13.1906 84.9178 15.9985 82.6763 19.049 80.7705C22.0689 78.8571 25.8703 78.4381 28.7459 76.239C26.1639 78.8167 22.3637 79.3758 19.3642 81.2872C16.7186 82.8943 13.1149 85.5389 10.5414 87.3388Z"
      fill="#C24950"
    />
    <path
      d="M53.6285 71.5439C50.3464 72.7701 47.3661 74.5012 44.5682 76.5717C41.5378 78.2818 37.7697 78.5703 35.3121 81.1509C37.382 78.2586 41.3619 77.7001 44.2779 76.0401C47.0848 73.974 50.2021 72.3313 53.6285 71.5439Z"
      fill="#5C2D33"
    />
    <path
      d="M36.1933 76.2473C30.5355 78.5651 26.2365 83.0438 21.0936 86.2126C20.9365 86.307 20.4678 86.593 20.302 86.6691C20.2467 86.678 20.0632 86.8213 20.0367 86.7331C20.1054 86.8149 20.4357 86.4912 20.5219 86.45C20.8214 86.2291 21.643 85.565 21.9445 85.3198C26.3805 81.8494 30.5966 77.7052 36.1933 76.2473Z"
      fill="#5C2D33"
    />
    <path
      d="M41.6566 88.4453C38.8834 89.5468 36.7194 91.5765 34.4409 93.4229C32.1213 95.2349 29.5177 96.6877 27.5342 98.8834C29.1575 96.3847 31.7835 94.7509 34.0747 92.9407C36.3758 91.0979 38.7074 89.111 41.6566 88.4453Z"
      fill="#5C2D33"
    />
    <g opacity="0.7">
      <path
        d="M56.7023 84.3248L23.5463 107.624C23.7345 108.185 7.84829 108.738 3.78952 102.992C6.19304 99.4012 12.6597 103.222 22.9285 100.085C49.1276 92.075 54.0864 82.1631 56.5144 76.2417C57.7814 80.2949 56.6991 84.3319 56.7023 84.3248Z"
        fill="#7C293B"
      />
    </g>
    <g opacity="0.4">
      <path
        d="M53.6262 71.5433C53.6262 71.5433 38.6892 66.3119 7.16786 89.4411C4.64903 91.2878 2.39053 92.7653 0.368378 93.9155C0.434944 91.6148 1.25236 89.6105 2.86898 88.5207C7.92287 85.1252 38.1676 67.9549 38.1745 67.9527C46.2152 67.2868 50.9198 69.0003 53.6262 71.5433Z"
        fill="#FFCA64"
      />
    </g>
    <path
      d="M23.5463 107.623C23.5463 107.623 18.3269 108.986 9.42052 106.527C0.520242 104.075 -2.1438 91.8929 2.86928 88.5204C12.2266 82.7143 29.3167 96.2302 23.5463 107.623Z"
      fill="#B66B41"
    />
    <g opacity="0.6">
      <path
        d="M18.1281 97.0087C22.592 101.965 15.4771 105.921 9.19845 102.194C3.10783 98.7495 3.18648 92.3175 7.40651 92.015C7.4497 91.6856 15.5001 93.2233 18.1281 97.0087Z"
        fill="#FFCA64"
      />
    </g>
    <path
      d="M105.35 65.1858C104.683 70.9444 100.116 84.3114 100.101 84.3977L63.4211 72.6755V60.1482L63.9659 59.9423L71.904 56.8967C71.904 56.8967 79.7689 60.7839 88.7968 62.2189C98.1101 64.2594 106.32 60.3645 105.35 65.1858Z"
      fill="#9E4B39"
    />
    <path
      d="M102.982 65.6046C99.8365 64.7069 96.4583 65.0265 93.2213 64.7802C91.2491 64.6576 89.3634 63.9545 87.3672 63.865C89.3432 63.5963 91.2556 64.1546 93.2484 64.2079C96.4797 64.3719 99.9972 64.1552 102.982 65.6046Z"
      fill="#5C2D33"
    />
    <path
      d="M70.6867 63.6605C73.1055 63.1427 75.3733 64.3137 77.6207 65.0168C79.8657 65.6853 82.3836 65.6131 84.5018 66.7305C82.2049 66.0637 79.7813 66.2721 77.4634 65.6009C75.2152 64.8946 73.1304 63.6267 70.6867 63.6605Z"
      fill="#5C2D33"
    />
    <path
      d="M86.1394 72.0842C87.3217 71.6858 88.6533 71.4344 89.856 71.9885C90.3465 72.292 90.8803 72.4905 91.4726 72.4582C92.6857 72.2977 93.9453 72.6751 95.1175 73.0222C96.8746 73.2954 99.0016 73.2031 100.364 74.5576C98.762 73.5096 96.8459 73.8139 95.0319 73.5888C93.8219 73.305 92.7677 72.9032 91.4621 73.03C89.202 72.7463 89.2795 71.516 86.1394 72.0842Z"
      fill="#5C2D33"
    />
    <g opacity="0.7">
      <path
        d="M105.35 65.1855C104.683 70.9441 100.116 84.3111 100.101 84.3975L63.421 72.6753V66.0089C79.3876 64.1561 91.3135 80.156 96.2802 73.6803C101.421 66.9775 104.8 65.6697 105.35 65.1855Z"
        fill="#7C293B"
      />
    </g>
    <path
      d="M100.101 84.3974C97.9728 83.1094 100.081 78.8646 100.996 73.8016C102.337 68.8507 103.088 64.5612 105.089 63.1389C110.69 67.1291 103.401 85.7051 100.101 84.3974Z"
      fill="#B66B41"
    />
    <g opacity="0.6">
      <path
        d="M99.2106 82.7806C99.0852 80.7826 102.447 67.3592 103.54 65.3125C107.003 69.2785 102.008 82.3567 99.2106 82.7806Z"
        fill="#FFCA64"
      />
    </g>
    <g opacity="0.4">
      <path
        d="M105.09 63.1391C105.09 63.1391 101.633 62.6486 91.6546 65.3128C82.2216 67.8316 75.0403 58.9068 63.9662 59.9423L71.9042 56.8967C71.9042 56.8967 79.7691 60.7839 88.797 62.2189C97.8243 63.6538 103.243 62.0675 105.09 63.1391Z"
        fill="#FFCA64"
      />
    </g>
    <path
      d="M52.6059 84.3247L85.762 107.623C85.762 107.623 90.9814 108.986 99.888 106.528C107.107 104.817 112.361 93.6404 106.439 88.5205C101.386 85.125 71.1404 67.9547 71.1339 67.9525C63.0932 67.2864 58.3888 68.9999 55.6822 71.5429C51.7532 74.5555 51.8609 82.674 52.6059 84.3247Z"
      fill="#9E4B39"
    />
    <path
      d="M98.7664 87.3388C96.1172 84.9178 93.3091 82.6763 90.2588 80.7705C87.2389 78.8571 83.4375 78.4381 80.5619 76.239C83.1439 78.8167 86.9441 79.3758 89.9436 81.2872C92.5892 82.8943 96.1929 85.5389 98.7664 87.3388Z"
      fill="#C24950"
    />
    <path
      d="M55.6794 71.5439C58.9615 72.7701 61.9418 74.5012 64.7397 76.5717C67.7701 78.2818 71.5382 78.5703 73.9958 81.1509C71.9259 78.2586 67.946 77.7001 65.03 76.0401C62.2231 73.974 59.1058 72.3313 55.6794 71.5439Z"
      fill="#5C2D33"
    />
    <path
      d="M73.1142 76.2473C78.772 78.5651 83.0711 83.0438 88.2139 86.2126C88.371 86.3071 88.8398 86.593 89.0056 86.6691C89.0609 86.678 89.2443 86.8213 89.2709 86.7331C89.2021 86.8149 88.8718 86.4912 88.7857 86.45C88.4859 86.2291 87.6645 85.565 87.363 85.3198C82.927 81.8494 78.711 77.7052 73.1142 76.2473Z"
      fill="#5C2D33"
    />
    <path
      d="M67.6512 88.4453C70.4244 89.5468 72.5884 91.5765 74.8669 93.4229C77.1864 95.2349 79.79 96.6877 81.7736 98.8834C80.1502 96.3847 77.5242 94.7509 75.233 92.9407C72.9319 91.0979 70.6001 89.111 67.6512 88.4453Z"
      fill="#5C2D33"
    />
    <g opacity="0.7">
      <path
        d="M52.6056 84.3248L85.7618 107.624C85.5744 108.185 101.459 108.738 105.519 102.992C103.115 99.4012 96.6484 103.222 86.3795 100.085C60.1805 92.075 55.2217 82.1631 52.7936 76.2417C51.5265 80.2949 52.6088 84.3319 52.6056 84.3248Z"
        fill="#7C293B"
      />
    </g>
    <g opacity="0.4">
      <path
        d="M55.6816 71.5433C55.6816 71.5433 70.6186 66.3119 102.14 89.4411C104.659 91.2878 106.917 92.7653 108.939 93.9155C108.873 91.6148 108.055 89.6105 106.439 88.5207C101.385 85.1252 71.1402 67.9549 71.1335 67.9527C63.0926 67.2868 58.388 69.0003 55.6816 71.5433Z"
        fill="#FFCA64"
      />
    </g>
    <path
      d="M85.7616 107.623C85.7616 107.623 90.9809 108.986 99.8876 106.527C108.788 104.075 111.452 91.8929 106.439 88.5204C97.0813 82.7143 79.9912 96.2302 85.7616 107.623Z"
      fill="#B66B41"
    />
    <g opacity="0.6">
      <path
        d="M91.1799 97.0087C86.716 101.965 93.8309 105.921 100.11 102.194C106.2 98.7495 106.121 92.3175 101.901 92.015C101.858 91.6856 93.8079 93.2233 91.1799 97.0087Z"
        fill="#FFCA64"
      />
    </g>
    <path
      d="M23.1681 39.6032C23.1681 39.6032 28.6602 48.5063 33.0605 47.6877C35.007 36.641 25.9209 29.4081 35.5166 14.4291C39.4559 32.6835 48.0271 15.1837 41.6567 0C41.6567 0 52.8111 0.51173 53.9368 13.0987C55.0625 25.6857 59.4628 25.0717 62.1235 15.4523C71.3326 21.7973 62.789 48.3819 75.12 29.4721C75.12 29.4721 78.6024 36.4308 73.9959 43.7989C69.3893 51.1669 75.3246 49.8366 77.0645 46.6642C84.9274 81.7835 18.9794 91.7164 23.1681 39.6032Z"
      fill="#FFCA64"
    />
    <path
      d="M34.7576 53.123C34.7576 53.123 38.0067 58.3901 40.6099 57.9057C41.7616 51.3707 36.3861 47.0914 42.0629 38.23C44.3925 49.028 49.4642 38.6787 45.6953 29.6938C45.6953 29.6938 52.2943 29.9966 52.9602 37.4431C53.626 44.8896 56.2292 44.5263 57.8035 38.8354C63.2516 42.5891 58.1971 58.3164 65.4921 47.1295C65.4921 47.1295 67.5523 51.2463 64.827 55.6052C62.1017 59.9641 65.6131 59.1772 66.6423 57.3003C71.2944 78.0763 32.2798 83.9534 34.7576 53.123Z"
      fill="#F89E62"
    />
    <path
      d="M40.5344 60.8706C40.5344 60.8706 42.6039 64.2252 44.2619 63.9168C44.9953 59.7544 41.5717 57.0289 45.1873 51.3849C46.671 58.2622 49.9014 51.6711 47.5009 45.948C47.5009 45.948 51.7039 46.1408 52.128 50.8836C52.5522 55.6265 54.2102 55.3951 55.2129 51.7706C58.6828 54.1614 55.4637 64.1785 60.1098 57.0533C60.1098 57.0533 61.422 59.6753 59.6863 62.4517C57.9506 65.2279 60.1869 64.7266 60.8425 63.5314C63.8055 76.7637 38.9562 80.507 40.5344 60.8706Z"
      fill="#F15169"
    />
  </svg>
);

export default IconFire;
